const transition = async (callback: () => void) => {
  if (!document.startViewTransition) {
    callback();
    return;
  }

  const t = document.startViewTransition(() => {
    callback();
  });

  return t.finished;
};

export default transition;
